import axios from 'axios';
import { AdresseIP } from './AdresseIp';

/*
 * Paiement d'une échéance de loyer via FASO ARZEKA (payment-proxy).
 *
 * Flux : initier() -> rediriger vers paymentUrl -> retour navigateur
 *        -> getStatut() en polling jusqu'à COMPLETED.
 *
 * paymentStatus : INIT | PENDING | COMPLETED | EXPIRED | INCOMPLETE
 * Le webhook /faso-arzeka/webhook est appelé par le proxy, jamais par le front.
 */
export class PaiementLoyerService {

    constructor(){
        this.adresse = new AdresseIP()
        this.base = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso'
    }

    /* callbackUrl est optionnel si return-url est configurée côté serveur. */
    initier(idEcheanceLoyer, callbackUrl) {
        const paiement = callbackUrl
            ? { idEcheanceLoyer : idEcheanceLoyer, callbackUrl : callbackUrl }
            : { idEcheanceLoyer : idEcheanceLoyer };
        return axios.post(this.base+'/paiement/initier', paiement)
                    .then(res => res.data);
    }
    getStatut(idEcheanceLoyer) {
        return axios.get(this.base+'/paiement/statut/'+idEcheanceLoyer)
                    .then(res => res.data);
    }
    /* Quittance d'un paiement validé (409 si l'échéance n'est pas payée). */
    getQuittance(idEcheanceLoyer) {
        return axios.get(this.base+'/paiement/'+idEcheanceLoyer+'/quittance')
                    .then(res => res.data);
    }
    /* PDF binaire de la quittance. */
    getQuittancePdf(idEcheanceLoyer) {
        return axios.get(this.base+'/paiement/'+idEcheanceLoyer+'/quittance.pdf', { responseType : 'blob' })
                    .then(res => res.data);
    }
    /* Force le rafraîchissement du statut auprès du proxy après retour navigateur. */
    rafraichirCallback(mappedOrderId) {
        return axios.get(this.base+'/faso-arzeka/callback/'+mappedOrderId)
                    .then(res => res.data);
    }

}
